define(function(require,exports){
    var type;
    var deepLinkPrefix;
    return function(typeOverride, deepLinkPrefixOverride){
        type = typeOverride || type;
        deepLinkPrefix = deepLinkPrefixOverride || deepLinkPrefix;
        return {
            type: typeof type === 'string' ? type : 'default',
            deepLinkPrefix: typeof deepLinkPrefix === 'string' ? deepLinkPrefix : 'mlbatbat',
        }
    }
});